export default "assets/images/plant-3ebf7370.svg";